export const toggleArrayElement = <T>(array: T[], value: T): T[] =>
  array.includes(value) ? array.filter((element) => element !== value) : [...array, value]

export const uniqueArray = <T>(array: T[]): T[] => Array.from(new Set(array))

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const groupBy = (list, keyGetter): Record<string, any> => {
  const map = new Map()
  list.forEach((item) => {
    const key = keyGetter(item)
    const collection = map.get(key)

    if (!collection) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })

  return map
}
